import React from 'react';
import Spinner from 'react-bootstrap/Spinner';


const LoadingButton = () => {
  return (
    <button type="button" className="loading-button" disabled={true}>
      <Spinner as="span" animation="border" size="sm"></Spinner> LOADING...
    </button>
  );
};

export default LoadingButton;